export const POPUP_FILTERS = {
  TYPE_OPTIONS: [
    {
      label: "-Select-",
      value: "",
    },
    {
      label: "Implementation Package",
      value: "I",
    },
    {
      label: "Kick Off Call",
      value: "K",
    },
    {
      label: "Training",
      value: "T",
    },
    {
      label: "Other",
      value: "O",
    },
  ],
  TIMES_OPTIONS: [
    {
      label: "AM",
      value: "AM",
    },
    {
      label: "PM",
      value: "PM",
    },
  ],
  TASK_TYPE_OPTIONS: [
    {
      label: "-Select-",
      value: "",
    },
    {
      label: "Training",
      value: "T",
    },
    {
      label: "Internal",
      value: "I",
    },
    {
      label: "Recurring",
      value: "R",
    },
  ],
  PRIORITY_OPTIONS: [
    {
      label: "Low",
      value: "Low",
    },
    {
      label: "Medium",
      value: "Medium",
    },
    {
      label: "High",
      value: "High",
    },
    {
      label: "Critical",
      value: "Critical",
    },
  ],
};
